<template>
  <div id="documents">
    <Breadcrumbs
      :crumbs="[
        { name: globals.info.school_name, link: `${pathPrefix}/` },
        { name: sectionName, link: `${pathPrefix}/documents` },
      ]"
    />
    <div class="page-container">
      <DocumentBreadcrumbs :crumbs="folderBreadcrumbs" />
      <DocumentList
        :content="foldersAndDocuments"
        :is-fetching="isFetching"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useDocumentsData } from '../../composables/useDocumentsData';
import Breadcrumbs from '../../components/global/Breadcrumbs.vue';
import DocumentList from '../../components/DocumentList.vue';
import DocumentBreadcrumbs from '../../components/global/DocumentBreadcrumbs.vue';
import { useNuxtApp, useHead, useRoute } from '#imports';

const store = useStore();
const route = useRoute();
const { $t } = useNuxtApp();

store.dispatch('setCustomSectionData', {
  type: 'documents',
  fallbackSectionName: $t('pages.documents.sectionName'),
});

const pathPrefix = computed(() => store.state.pathPrefix);
const sectionName = computed(() => store.state.sectionName);
const globals = computed(() => store.state.globals);

useHead({
  title: sectionName.value,
});

const folderId = computed(() => route.params?.slug?.at(-1));

const { isFetching, foldersAndDocuments, folderBreadcrumbs } = useDocumentsData(folderId.value);
</script>
